const translations = {
  de: {
    // Navbar
    nav_home: "Startseite",
    nav_listings: "Unterkünfte",
    nav_contact: "Kontakt",
    nav_tips: "Wien Tipps",

    // Hero
    hero_title: "Ihr perfekter Aufenthalt mit Oona Flats",
    hero_subtitle: "Entdecken Sie handverlesene Apartments mit Stil und Komfort",
    hero_search_placeholder: "Wohin möchten Sie?",
    hero_search_button: "Suchen",

    // Video Section
    video_label: "Erleben Sie Luxus",
    video_title: "Wohnen wie zu Hause, fühlen wie im Urlaub",
    video_description: "Unsere Design-Apartments vereinen modernen Stil mit Wiener Charme – jedes Detail sorgfältig ausgewählt für Ihren perfekten Aufenthalt.",
    video_cta: "Unterkünfte entdecken",

    // Features
    feature_style_title: "Stilvoll eingerichtet",
    feature_style_desc: "Jede Unterkunft ist individuell und modern gestaltet, für maximalen Komfort.",
    feature_location_title: "Beste Lage",
    feature_location_desc: "Zentral gelegen mit perfekter Anbindung an alle Sehenswürdigkeiten.",
    feature_secure_title: "Sicher buchen",
    feature_secure_desc: "Sichere Bezahlung und flexibles Stornieren für Ihre Sicherheit.",

    // Listings
    listings_label: "Unsere Auswahl",
    listings_title: "Unterkünfte",
    listings_view_all: "Alle anzeigen",
    listings_view_all_mobile: "Alle Unterkünfte",
    listings_page_label: "Entdecken",
    listings_page_title: "Alle Unterkünfte",
    listings_available: "Unterkünfte verfügbar",
    listings_loading: "Wird geladen...",
    listings_load_error: "Unterkünfte konnten nicht geladen werden.",
    listings_retry: "Erneut versuchen",
    listings_none: "Keine Unterkünfte gefunden",
    listings_none_hint: "Versuchen Sie andere Suchbegriffe oder Filter",
    listings_search_prefix: "Suche",

    // Filters
    filter_label: "Filter:",
    filter_sort_default: "Standard",
    filter_sort_price_asc: "Preis aufsteigend",
    filter_sort_price_desc: "Preis absteigend",
    filter_sort_capacity: "Max. Gäste",
    filter_guests_all: "Alle",
    filter_guests_2: "2+ Gäste",
    filter_guests_4: "4+ Gäste",
    filter_guests_6: "6+ Gäste",
    filter_reset: "Zurücksetzen",

    // Listing Card
    card_from: "ab",
    card_per_night: "/ Nacht",

    // Listing Detail
    detail_back: "Zurück",
    detail_guests: "Gäste",
    detail_bedrooms: "Schlafzimmer",
    detail_bathrooms: "Badezimmer",
    detail_area: "Fläche",
    detail_description: "Beschreibung",
    detail_amenities: "Ausstattung",
    detail_amenities_more: "weitere Ausstattungsmerkmale",
    detail_checkin: "Check-in",
    detail_checkout: "Check-out",
    detail_house_rules: "Hausregeln",
    detail_location: "Standort",
    detail_per_night: "/ Nacht",
    detail_min_nights: "Mindestaufenthalt",
    detail_nights: "Nächte",
    detail_night: "Nacht",
    detail_not_found: "Unterkunft nicht gefunden",
    detail_load_error: "Die Unterkunft konnte nicht geladen werden.",
    detail_back_to_listings: "Zurück zu Unterkünften",

    // Booking
    booking_dates_label: "Anreise & Abreise",
    booking_guests_label: "Gäste",
    booking_guest_singular: "Gast",
    booking_guests_plural: "Gäste",
    booking_name: "Name",
    booking_name_placeholder: "Vollständiger Name",
    booking_email: "E-Mail",
    booking_email_placeholder: "ihre@email.com",
    booking_phone: "Telefon (optional)",
    booking_phone_placeholder: "+43 ...",
    booking_nights: "Nächte",
    booking_cleaning_fee: "Reinigungsgebühr",
    booking_extra_guests: "Zusätzliche Gäste",
    booking_total: "Gesamt",
    booking_button: "Jetzt buchen",

    // Booking Success
    success_checking: "Zahlung wird überprüft",
    success_wait: "Bitte warten Sie einen Moment...",
    success_title: "Buchung bestätigt!",
    success_message: "Vielen Dank, {name}. Ihre Buchung wurde erfolgreich abgeschlossen.",
    success_reservation: "Reservierung #{id} bei Hostaway bestätigt",
    success_paid: "Bezahlt",
    success_home: "Zur Startseite",
    success_more: "Mehr Unterkünfte",
    success_expired: "Sitzung abgelaufen",
    success_timeout: "Zeitüberschreitung",
    success_error: "Fehler",
    success_expired_msg: "Ihre Zahlungssitzung ist abgelaufen. Bitte versuchen Sie es erneut.",
    success_timeout_msg: "Die Statusprüfung hat zu lange gedauert. Bitte überprüfen Sie Ihre E-Mail.",
    success_error_msg: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    success_back: "Zurück zu Unterkünften",

    // Contact
    contact_title: "Kontakt",
    contact_subtitle: "Haben Sie Fragen? Wir helfen Ihnen gerne weiter.",
    contact_name: "Name",
    contact_name_placeholder: "Ihr Name",
    contact_email: "E-Mail",
    contact_email_placeholder: "ihre@email.com",
    contact_subject: "Betreff",
    contact_subject_placeholder: "Worum geht es?",
    contact_message: "Nachricht",
    contact_message_placeholder: "Ihre Nachricht an uns...",
    contact_send: "Nachricht senden",
    contact_success_title: "Nachricht gesendet!",
    contact_success_msg: "Vielen Dank für Ihre Nachricht. Wir melden uns schnellstmöglich bei Ihnen.",
    contact_another: "Weitere Nachricht senden",
    contact_direct: "Oder schreiben Sie uns direkt an",

    // Recommendations
    reco_label: "Für unsere Gäste",
    reco_title: "Wien entdecken",
    reco_subtitle: "Unsere persönlichen Empfehlungen für Restaurants, Cafés und Sehenswürdigkeiten – damit Ihr Aufenthalt unvergesslich wird.",
    reco_cat_all: "Alle",
    reco_cat_restaurant: "Restaurants",
    reco_cat_cafe: "Cafés",
    reco_cat_sight: "Sehenswürdigkeiten",
    reco_cat_nature: "Natur & Parks",
    reco_tip: "Tipp",
    reco_website: "Website besuchen",
    reco_none: "Keine Empfehlungen in dieser Kategorie",

    // Footer
    footer_desc: "Finden Sie Ihre perfekte Unterkunft in Wien. Moderne Apartments, stilvoll eingerichtet und zentral gelegen. oonaflats.com",
    footer_nav: "Navigation",
    footer_contact: "Kontakt",
    footer_rights: "Alle Rechte vorbehalten.",

    // Photos
    photos_more: "Fotos",

    // Map
    map_no_locations: "Keine Standorte verfügbar",
  },

  en: {
    // Navbar
    nav_home: "Home",
    nav_listings: "Apartments",
    nav_contact: "Contact",
    nav_tips: "Vienna Tips",

    // Hero
    hero_title: "Your Perfect Stay with Oona Flats",
    hero_subtitle: "Discover handpicked apartments with style and comfort",
    hero_search_placeholder: "Where would you like to go?",
    hero_search_button: "Search",

    // Video Section
    video_label: "Experience Luxury",
    video_title: "Feel at home, live like on vacation",
    video_description: "Our design apartments combine modern style with Viennese charm – every detail carefully selected for your perfect stay.",
    video_cta: "Discover apartments",

    // Features
    feature_style_title: "Stylishly furnished",
    feature_style_desc: "Each apartment is individually and modernly designed for maximum comfort.",
    feature_location_title: "Best location",
    feature_location_desc: "Centrally located with perfect connections to all attractions.",
    feature_secure_title: "Book safely",
    feature_secure_desc: "Secure payment and flexible cancellation for your peace of mind.",

    // Listings
    listings_label: "Our Selection",
    listings_title: "Apartments",
    listings_view_all: "View all",
    listings_view_all_mobile: "All Apartments",
    listings_page_label: "Discover",
    listings_page_title: "All Apartments",
    listings_available: "apartments available",
    listings_loading: "Loading...",
    listings_load_error: "Apartments could not be loaded.",
    listings_retry: "Try again",
    listings_none: "No apartments found",
    listings_none_hint: "Try different search terms or filters",
    listings_search_prefix: "Search",

    // Filters
    filter_label: "Filter:",
    filter_sort_default: "Default",
    filter_sort_price_asc: "Price ascending",
    filter_sort_price_desc: "Price descending",
    filter_sort_capacity: "Max. guests",
    filter_guests_all: "All",
    filter_guests_2: "2+ Guests",
    filter_guests_4: "4+ Guests",
    filter_guests_6: "6+ Guests",
    filter_reset: "Reset",

    // Listing Card
    card_from: "from",
    card_per_night: "/ night",

    // Listing Detail
    detail_back: "Back",
    detail_guests: "Guests",
    detail_bedrooms: "Bedrooms",
    detail_bathrooms: "Bathrooms",
    detail_area: "Area",
    detail_description: "Description",
    detail_amenities: "Amenities",
    detail_amenities_more: "more amenities",
    detail_checkin: "Check-in",
    detail_checkout: "Check-out",
    detail_house_rules: "House Rules",
    detail_location: "Location",
    detail_per_night: "/ night",
    detail_min_nights: "Minimum stay",
    detail_nights: "nights",
    detail_night: "night",
    detail_not_found: "Apartment not found",
    detail_load_error: "The apartment could not be loaded.",
    detail_back_to_listings: "Back to apartments",

    // Booking
    booking_dates_label: "Check-in & Check-out",
    booking_guests_label: "Guests",
    booking_guest_singular: "Guest",
    booking_guests_plural: "Guests",
    booking_name: "Name",
    booking_name_placeholder: "Full name",
    booking_email: "Email",
    booking_email_placeholder: "your@email.com",
    booking_phone: "Phone (optional)",
    booking_phone_placeholder: "+43 ...",
    booking_nights: "nights",
    booking_cleaning_fee: "Cleaning fee",
    booking_extra_guests: "Additional guests",
    booking_total: "Total",
    booking_button: "Book now",

    // Booking Success
    success_checking: "Verifying payment",
    success_wait: "Please wait a moment...",
    success_title: "Booking confirmed!",
    success_message: "Thank you, {name}. Your booking has been completed successfully.",
    success_reservation: "Reservation #{id} confirmed at Hostaway",
    success_paid: "Paid",
    success_home: "Go to homepage",
    success_more: "More apartments",
    success_expired: "Session expired",
    success_timeout: "Timeout",
    success_error: "Error",
    success_expired_msg: "Your payment session has expired. Please try again.",
    success_timeout_msg: "The status check took too long. Please check your email.",
    success_error_msg: "An error occurred. Please try again.",
    success_back: "Back to apartments",

    // Contact
    contact_title: "Contact",
    contact_subtitle: "Have questions? We're happy to help.",
    contact_name: "Name",
    contact_name_placeholder: "Your name",
    contact_email: "Email",
    contact_email_placeholder: "your@email.com",
    contact_subject: "Subject",
    contact_subject_placeholder: "What is it about?",
    contact_message: "Message",
    contact_message_placeholder: "Your message to us...",
    contact_send: "Send message",
    contact_success_title: "Message sent!",
    contact_success_msg: "Thank you for your message. We'll get back to you as soon as possible.",
    contact_another: "Send another message",
    contact_direct: "Or write to us directly at",

    // Recommendations
    reco_label: "For our guests",
    reco_title: "Discover Vienna",
    reco_subtitle: "Our personal recommendations for restaurants, cafés and attractions – to make your stay unforgettable.",
    reco_cat_all: "All",
    reco_cat_restaurant: "Restaurants",
    reco_cat_cafe: "Cafés",
    reco_cat_sight: "Attractions",
    reco_cat_nature: "Nature & Parks",
    reco_tip: "Tip",
    reco_website: "Visit website",
    reco_none: "No recommendations in this category",

    // Footer
    footer_desc: "Find your perfect accommodation in Vienna. Modern apartments, stylishly furnished and centrally located. oonaflats.com",
    footer_nav: "Navigation",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",

    // Photos
    photos_more: "Photos",

    // Map
    map_no_locations: "No locations available",
  },
};

export default translations;
